import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";

export const GET_POLICY_TYPE_LIST = 'GET_POLICY_TYPE_LIST';

export const service = async () => {
  const options: object = {
      url: `/Api/PolicySearch/GetPolicyTypeList`,
    method: "GET",
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_POLICY_TYPE_LIST, service, mock);